import CtaButtonGroup from "@/components/molecules/CtaButtonGroup";
import { IdeaToIncomeProps } from "@/shared/data/home.v2.data";
import classNames from "classnames";
import SectionHeader from "@/components/Home/v2/shared/SectionHeader";
import Text from "@/components/Home/v2/shared/Text";


const ProductCardGridSection = ({
  eyebrow,
  title,
  subtitle,
  cards,
  ctas,
  columns = 2,
}: IdeaToIncomeProps) => {
  const sentenceIdx = title.indexOf(". ");
  let titleMuted = title;
  let titleBright = "";
  if (sentenceIdx > -1) {
    titleMuted = title.slice(0, sentenceIdx + 1);
    titleBright = title.slice(sentenceIdx + 2);
  }

  const gridColsClass =
    columns === 3 ? "md:grid-cols-3" : "md:grid-cols-2";

  return (
    <section className="w-full bg-white">
      <div className="container mx-auto px-4 py-10 sm:px-6 md:px-8 md:py-20 lg:px-12 lg:py-24">
        <SectionHeader
          eyebrow={eyebrow}
          titleMuted={titleMuted}
          titleBright={titleBright || undefined}
          title={titleBright ? undefined : title}
          subtitle={subtitle}
          variant="light-teal"
          align="center"
        />

        {ctas && ctas.length ? (
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3 md:mt-10">
            <CtaButtonGroup
              ctas={ctas}
              gap="flex gap-3"
              fullWidthOnMobile={false}
            />
          </div>
        ) : null}

        <div
          className={classNames(
            "mx-auto mt-12 grid max-w-6xl gap-6 md:items-stretch md:gap-8",
            gridColsClass
          )}
        >
          {cards.map((card) => (
            <div
              key={card.title}
              className={classNames(
                "flex h-full flex-col overflow-hidden rounded-3xl bg-white border border-[#E5E5E5]"
              )}
            >
              {/* Image block TOP — padded with rounded corners. */}
              <div className="p-5 pb-0 md:p-6 md:pb-0">
                <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl bg-slate-50">
                  {card.image ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                      src={card.image}
                      alt=""
                      aria-hidden="true"
                      className={classNames(
                        "absolute inset-0 h-full w-full object-contain",
                        card.imageMobile ? "hidden md:block" : "block"
                      )}
                    />
                  ) : null}
                  {card.imageMobile ? (
                    // eslint-disable-next-line @next/next/no-img-element
                    <img
                      src={card.imageMobile}
                      alt=""
                      aria-hidden="true"
                      className={classNames(
                        "absolute inset-0 h-full w-full object-contain",
                        card.image ? "block md:hidden" : "block"
                      )}
                    />
                  ) : null}
                </div>
              </div>
              {/* Text block BELOW — left aligned. */}
              <div className="p-5 md:p-6">
                <Text as="h3" variant="title-lg" className="text-neutralBlack">
                  {card.title}
                </Text>
                <Text
                  as="p"
                  variant="body-lg"
                  className="mt-2 text-darkSlate04"
                >
                  {card.description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCardGridSection;
